export class CompanyFormValues {

    _name; // string
    _nif; // string
    _phone; // string
    _ccc; // string
    _contactPerson; // string
    _email; // string
    _address; // string

    constructor(
        name,
        nif,
        phone,
        ccc,
        contactPerson,
        email,
        address,
    ) {
        this._name = name;
        this._nif = nif;
        this._phone = phone;
        this._ccc = ccc;
        this._contactPerson = contactPerson;
        this._email = email;
        this._address = address;
    }

    static null() {
        return new this(
            '',
            '',
            '',
            '',
            '',
            '',
            '',
        );
    }

    static fromCompany(company) {
        return new this(
            company.name(),
            company.nif(),
            company.phone(),
            company.ccc(),
            company.contactPerson(),
            company.email(),
            company.address(),
        );
    }

    initialValues() {
        return {
            name: this._name,
            nif: this._nif,
            phone: this._phone,
            ccc: this._ccc,
            contactPerson: this._contactPerson,
            email: this._email,
            address: this._address,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/my-company/company/form/CompanyFormValues.js